import { ContentOptions, DashboardContentOptions, FrameOptions } from 'amazon-quicksight-embedding-sdk';

export class FrameOptionsBuilder {
  frameOptions: FrameOptions;

  constructor(url: string, container: string) {
    this.frameOptions = {
      url,
      container,
      width: '100%',
      height: '100%',
      className: 'quicksight-iframe',
    };
  }

  withOnChange(onChange) {
    this.frameOptions.onChange = onChange;

    return this;
  }

  withWidth(width) {
    this.frameOptions.width = width;

    return this;
  }

  withHeight(height) {
    this.frameOptions.height = height;
    return this;
  }

  build() {
    return this.frameOptions;
  }
}

export class DashboardContentOptionsBuilder {
  contentOptions: DashboardContentOptions;

  constructor() {
    this.contentOptions = {
      parameters: [],
    };
  }

  withParameter(name: string, value: string) {
    this.contentOptions.parameters.push({
      Name: name,
      Values: [value],
    });

    return this;
  }

  withParameters(name: string, values: string[]) {
    this.contentOptions.parameters.push({
      Name: name,
      Values: values,
    });

    return this;
  }

  withSheetOptions(sheetId: string, singleSheet: boolean) {
    this.contentOptions.sheetOptions = {
      initialSheetId: sheetId,
      singleSheet,
    };
    return this;
  }

  withSheetTabsDisabled(disabled: boolean) {
    if (!this.contentOptions.sheetOptions) {
      this.contentOptions.sheetOptions = {};
    }
    this.contentOptions.sheetOptions.singleSheet = disabled;
    return this;
  }

  withToolbarOptions(options: { export?: boolean; undoRedo?: boolean; reset?: boolean; bookmarks?: boolean }) {
    this.contentOptions.toolbarOptions = options;
    return this;
  }

  build(): ContentOptions {
    return this.contentOptions;
  }
}
